var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { Card } from '@philips-internal/oswald-ui-components/lib/components';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import MedicineAndSolutionsCardAPI from './medicine-and-solutions-card-api';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import './medicine-and-solutions-card.css';
let MedicineAndSolutionsCard = class MedicineAndSolutionsCard extends Component {
    constructor() {
        super(...arguments);
        this.handleCardClick = () => {
            const { materialDescription, onClick } = this.props;
            if (isFunction(onClick)) {
                onClick(new ClickEvent({
                    value: {
                        materialDescription,
                    }
                }));
            }
        };
    }
    static { this.propTypes = {
        onClick: eventListener
    }; }
    render() {
        const { materialDescription } = this.props;
        return (React.createElement(Card, { className: 'c-medicine-and-solutions-card', onClick: () => this.handleCardClick(), selectionType: SelectionType.SINGLE, uuid: generateUUID(), key: `${materialDescription} + ${new Date()}`, width: 12 },
            React.createElement("div", { className: 'c-medicine-and-solutions-title-item' }, this.props.materialDescription)));
    }
};
MedicineAndSolutionsCard = __decorate([
    AwesomeComponent({ api: MedicineAndSolutionsCardAPI, type: ComponentType.DATA_DISPLAY })
], MedicineAndSolutionsCard);
export default MedicineAndSolutionsCard;
//# sourceMappingURL=medicine-and-solutions-card.js.map